const { REACT_APP_API_URL } = process.env;

export const GRAPHQL_ENDPOINT = `${REACT_APP_API_URL}/graphql`;
export const SIGNIN_ENDPOINT = `${REACT_APP_API_URL}/auth/interviewer/signin`;
export const SIGNUP_ENDPOINT = `${REACT_APP_API_URL}/auth/interviewer/finish_registration`;
export const GET_INTERVIEWER_ENDPOINT = `${REACT_APP_API_URL}/auth/interviewer/get_interviewer_from_invitation`;
export const PASSWORD_RESET_EMAIL_ENDPOINT = `${REACT_APP_API_URL}/auth/interviewer/password_reset_email`;
